module.exports = __webpack_public_path__ + "static/hacienda_datos-5f5fb547c7750625b0d62ec00178bd06.jpg";